import { api } from "api/api";
import { AxiosError } from "axios";
import NivelAprovacao from "model/administracao/cadastro/nivelaprovacao/NivelAprovacao";
import Usuario from "model/administracao/cadastro/Usuario";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import { generateKey } from "utils/generateKey";

class NivelAprovacaoService implements BaseServiceCadastros<NivelAprovacao> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {

            let url = `/nivelaprovacao/pesquisar`;
            url += getFilters(filters)

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<NivelAprovacao>((resolve, reject): void => {
            api
                .get(`/nivelaprovacao/consultar/${id}`)
                .then(response => {
                    const nivelAprovacao: NivelAprovacao = response.data;
                    nivelAprovacao.nivelAprovacaoUsuarios.forEach(item => {
                        item.key = generateKey();
                        return item;
                    });
                    resolve(nivelAprovacao);
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(nivelAprovacao: NivelAprovacao) {
        return new Promise<NivelAprovacao>((resolve, reject): void => {
            let url = `/nivelaprovacao/incluir`;
            api
                .post(url, JSON.stringify(nivelAprovacao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(nivelAprovacao: NivelAprovacao) {
        return new Promise<NivelAprovacao>((resolve, reject): void => {
            api
                .put(`/nivelaprovacao/editar`, JSON.stringify(nivelAprovacao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/nivelaprovacao/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTipoRotina(tipoRotina: string): string {

        if (tipoRotina === 'VIAGEM') {
            return 'Viagem';
        }

        return '';
    }

    usuarios() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/nivelaprovacao/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default NivelAprovacaoService;
